export default {"src":"/_next/static/media/error-artwork.b9c35342.svg","height":194,"width":250};